<template>
    <div class="wrapper blog-post">
        <div class="page-header page-header-small" v-if="!headerSimple">
            <parallax class="page-header-image" v-bind:style="{ backgroundImage: 'url(' + mensaje('img5') + ')' }"></parallax>
        </div>
        <!--<span v-if="$store.state.editor==true" class="texto-editor-img" style="transform: translate(200%,-200%); line-height: normal;">nosotros.json->mensajes:img5</span>-->
        
        <div class="page-head2 page-header-mini" v-if="headerSimple" :style="{ marginBottom: `${logo_altura}px` }">
        </div>

        <div class="container">
            <div class="row">
                <div class="col-md-10 ml-auto mr-auto">
                    <!--<h3 class="title">{{mensaje('tit10')}}</h3>-->
                    <h3 class="title">Pago de recibos online</h3>
                    <!--<span v-if="$store.state.editor==true" class="texto-editor-img" style="transform: translate(200%,-200%); line-height: normal;">nosotros.json->mensajes:tit10</span>-->
                    <!--<span v-if="$store.state.editor==true" class="texto-editor-img" style="transform: translate(200%,50%); line-height: normal;">nosotros.json->mensajes:men10 <i>HTML</i></span>-->
                    <p>En el presente formulario se detallan los productos o servicios que Ud. podrá abonar a través de una plataforma de pago bancaria segura. Compruebe que sus datos son correctos y marque las casillas de verificación aplicables.</p>
                    
                    <div class="row">
                      <div class="col-sm-6 col-md-5 pl-2">
                        <card>
                          <h4 class="card-title">Datos de Pago</h4>
                          <!--<h6 class="card-subtitle mb-2 text-muted">Cliente:</h6>-->
                          <p class="card-text" style="font-size: 15px;"><b>CLIENTE: </b>{{nombre}}<br>
                          <b>CIF: </b>{{cif}}<br>
                          <b>EMAIL: </b>{{email}}<br>
                          <b>FACTURA: </b>{{idfactura}}<br>
                          <b>DESCRIPCIÓN: </b>{{descrip}}<br>
                          </p>
                          <p class="card-text text-right" style="font-size: 14px;">PVP (IVA incluído) <b>{{importe}}€</b></p>
                        </card>
                      </div>
                    </div>
                    
                    <hr>
                    
                    <!-- Autorizar contrato -->
                    <div class="col-md-12 pl-2" style="padding-top:30px;">
                      <span>Estos son los <router-link v-popover:popover1 to="/terminos">términos de <b>aceptación del contrato</b></router-link>. Estoy de acuerdo con todos los términos definidos en este contrato con Allbox Manager. <router-link v-popover:popover1 to="/cookies"><b>Política de privacidad</b></router-link> Si no acepta estos términos no se realizará la operación de reserva.</span>
                      <n-checkbox v-model="autorizo">Acepto los términos definidos en este contrato.</n-checkbox>
                    </div>
                    
                    <!-- Autorizar recurrente -->
                    <div class="row pl-3" style="padding-bottom: 30px;">
                      <div v-if="pagopasarela==true" class="col-md-12 pl-2" style="padding-left: 20px; padding-top: 5px;">
                        <div class="row" style="padding-top:5px; padding-left: 15px;">
                          <n-checkbox 
                              v-model="pagorec" :disabled="lockrecur === true">
                              <span style="color: #000000 !important;">
                                  Autorizar pagos recurrentes para futuras operaciones.
                              </span>
                          </n-checkbox>
                        </div>
                      </div>
                    </div>
                    
                    <n-button type="info" size="lg" @click.native="enviacontrato" style="cursor: default; opacity: 1;">Pago Seguro
                      <el-tooltip class="tooltip-message" content="Debes aceptar las condiciones" placement="top">
                        <i class="el-icon-info"></i>
                      </el-tooltip>
                    </n-button>
                    
                    </div>
                    


                </div>
            </div>
        </div>
</template>
<script>
  
  
  import { Card, Button, Comment, Badge, DropDown, FormGroupInput, InfoSection, Modal, Checkbox } from '@/components';
  import {Select, Option, Tag, Steps, Step, Radio, DatePicker, Tooltip, Switch, Notification} from 'element-ui';
  import 'element-ui/lib/theme-chalk/index.css'
  import 'element-ui/lib/theme-chalk/icon.css'
  import 'element-ui/lib/theme-chalk/radio.css'
  import {RUTA_BASE, RUTA_PHP} from '@/constants'
  import axios from "axios"

  export default {
    name: 'pagos',
    bodyClass: 'blog-post',
    
    components: {
      Modal,
      Card,
      InfoSection,
      Badge,
      Comment,
      [Button.name]: Button,
      [Checkbox.name]: Checkbox,
      [Radio.name]: Radio,
      [Select.name]: Select,
      [Option.name]: Option,
      [DatePicker.name]: DatePicker,
      [Tooltip.name]: Tooltip,
      [Switch.name]: Switch,
      [Step.name]: Step,
      [Steps.name]: Steps,
      [Tag.name]: Tag,
      [FormGroupInput.name]: FormGroupInput,
      [Notification.name]: Notification,
    },
    
    data() {
      return {
        datos: this.$route.query.datos,
        mensajes: [],
        headerSimple: false,
        logo_altura: 0,
        pagorec: true,
        autorizo: false,
        pagopasarela: true,
        ape1: '',
        ape2: '',
        nom: '',
        nombre: '',
        centro: '',
        cif: '',
        email: '',
        idfactura: '',
        idfactint: '',
        idrecint:'',
        importe: '',
        uid: '',
        descrip: '',
        deshabilitaCheck: '',
        lockrecur: "",

      }
    },

    watch: {
      '$store.state.idioma': {
        handler(newValue, oldValue) {
          // Acciones a realizar cuando la variable cambia
          console.log('La variable ha cambiado', newValue)
          this.cambiaIdioma(newValue)
        },
        deep: true, // Opcional: vigila cambios profundos en la variable
      },
    },
    methods: {
      cambiaIdioma(nuevoValor) {
        var numIdioma = this.$store.state.idiomas[nuevoValor]
        var cadJson = 'json/nosotros'+numIdioma.toString()+'.json'
        axios.get(RUTA_BASE+cadJson)
        .then(response => {
          this.mensajes = response.data.mensajes;
          this.lockrecur = response.data.lockrecur;
          console.log("locked?: ",this.lockrecur)
          // BORRA la línea repetida anterior y deja solo esta:
          this.deshabilitaCheck = String(response.data.deshabilitaCheck) === "true";
        })
        .catch(error => console.log(error))
      },
      leeDatos() {
        var params = new URLSearchParams()
        params.append('datos', this.datos)
        axios.post(RUTA_PHP+'transacCobroTarjetaDec.php',params)
        .then(response => {
            console.log('transacCobroTarjetaDec.php: ',response.data)
            
            this.ape1 = response.data.APE_1
            this.ape2 = response.data.APE_2
            this.nom = response.data.NOM
            this.nombre = this.nom + " " + this.ape1 + " " + this.ape2
            this.centro = response.data.CENTRO
            this.cif = response.data.CIF
            this.email = response.data.EMAIL
            this.idfactura = response.data.IDFACTURA
            this.idfactint = response.data.IDFACTINT
            this.idrecint = response.data.IDRECINT
            this.importe = response.data.IMPORTE
            this.uid = response.data.UID
            this.descrip = response.data.DESCRIP
            
            
            
            
        })
        .catch(error => console.log(error))
        
      },
      mensaje(nom) {
        var mens = ''
        this.mensajes.forEach(elemento => {
          if (elemento.nombre==nom) {
            mens = elemento.mensaje
          }
        })
        return(mens)
      },
      enviacontrato() {
        if (this.autorizo==true) {
          console.log('pagorec: ',this.pagorec)
          if (this.pagorec==true) {
            var precstr = this.importe.replace(',','')
            // GENERAMOS EL PAGO AUTORIZANDO FUTUROS PAGOS RECURRENTES
            var oRef = {
              "CENTRO": this.centro,
              "NOMBRE": this.nom,
              "APELLIDO1": this.ape1,
              "APELLIDO2": this.ape2,
              "EMAIL": this.email,
              "CIF": this.cif,
              "IDFACTURA": this.idfactura,
              "IDFACTINT": this.idfactint,
              "IDRECINT": this.idrecint,
              "UID": this.uid,
              "DESCRIP": this.descrip,
              "IMPORTE": this.importe.replace(',','.'),
              "ORIGEN": 'PAGO_ONLINE'
            }
            console.log("oRef: ",oRef)
            var merData = JSON.stringify(oRef)
            console.log("merData: ",merData)
            var ord2 = getRandomInt(100,999).toString(36)+getId()  // hasta 12 dígitos alfanuméricos
            //console.log("ord2: ",ord2)
            //var impo = this.contrato.precio
            //var impo2 = impo.replace(".","")
            //console.log("impo2: ",impo2)
            var params = new URLSearchParams()
            params.append('order', ord2)
            params.append('importe', precstr)
            params.append('merdata', merData)
            params.append('centro', this.centro)
            params.append('usuario', "")
            params.append('dni1', "")
            params.append('dni2', "")
            params.append('email', this.email)
            axios.post(RUTA_PHP+'pasarela_contrato_autoriz.php', params)
            .then((respuesta) => {
              if (respuesta.data.params=="KO") {
                Notification.info({
                  title: "ERROR",
                  message: "Factura ya pagada",
                  duration: 0
                });
              } else {
                // Crea formulario
                var mapForm = document.createElement("form");
                //mapForm.target = "_blank"; 
                mapForm.target = "_self";   
                mapForm.method = "POST";
                mapForm.action = this.$store.state.ruta_pasarela_banco;
                // Crea un input
                var mapInput = document.createElement("input");
                mapInput.type = "hidden";
                mapInput.name = "Ds_SignatureVersion";
                mapInput.value = "HMAC_SHA256_V1";
                // Añade el input al formulario
                mapForm.appendChild(mapInput);
                // Crea un input
                var mapInput2 = document.createElement("input");
                mapInput2.type = "hidden";
                mapInput2.name = "Ds_MerchantParameters";
                mapInput2.value = respuesta.data.params;
                // Añade el input al formulario
                mapForm.appendChild(mapInput2);
                // Crea un input
                var mapInput3 = document.createElement("input");
                mapInput3.type = "hidden";
                mapInput3.name = "Ds_Signature";
                mapInput3.value = respuesta.data.signature;
                // Añade el input al formulario
                mapForm.appendChild(mapInput3);
                // Añade el formulario al dom
                document.body.appendChild(mapForm);
                // Hace el submit del formulario
                mapForm.submit();
              }
              
            })
            .catch((error) => {
               console.log('error: ',error)
            });
  
          } else {
            var precstr = this.importe.replace(',','')
            // GENERAMOS SOLO EL PAGO DE ESTA RESERVA
            var oRef = {
              "CENTRO": this.centro,
              "NOMBRE": this.nom,
              "APELLIDO1": this.ape1,
              "APELLIDO2": this.ape2,
              "EMAIL": this.email,
              "CIF": this.cif,
              "IDFACTURA": this.idfactura,
              "IDFACTINT": this.idfactint,
              "IDRECINT": this.idrecint,
              "UID": this.uid,
              "DESCRIP": this.descrip,
              "IMPORTE": this.importe.replace(',','.'),
              "ORIGEN": 'PAGO_ONLINE'
            }
            console.log("oRef: ",oRef)
            var merData = JSON.stringify(oRef)
            console.log("merData: ",merData)
            var ord2 = getRandomInt(100,999).toString(36)+getId()  // hasta 12 dígitos alfanuméricos
            console.log("ord2: ",ord2)
            var params = new URLSearchParams()
            params.append('order', ord2)
            params.append('importe', precstr)
            params.append('merdata', merData)
            params.append('centro', this.centro)
            params.append('usuario', "")
            params.append('dni1', "")
            params.append('dni2', "")
            params.append('email', this.email)
            axios.post(RUTA_PHP+'pasarela_contrato.php', params)
            .then((respuesta) => {
              console.log("Respuesta: ", respuesta)
              if (respuesta.data.params=="KO") {
                Notification.info({
                  title: "ERROR",
                  message: "Factura ya pagada",
                  duration: 0
                });
              } else { 
                // Crea formulario
                var mapForm = document.createElement("form");
                //mapForm.target = "_blank"; 
                mapForm.target = "_self";   
                mapForm.method = "POST";
                mapForm.action = this.$store.state.ruta_pasarela_banco;
                // Crea un input
                var mapInput = document.createElement("input");
                mapInput.type = "hidden";
                mapInput.name = "Ds_SignatureVersion";
                mapInput.value = "HMAC_SHA256_V1";
                // Añade el input al formulario
                mapForm.appendChild(mapInput);
                // Crea un input
                var mapInput2 = document.createElement("input");
                mapInput2.type = "hidden";
                mapInput2.name = "Ds_MerchantParameters";
                mapInput2.value = respuesta.data.params;
                // Añade el input al formulario
                mapForm.appendChild(mapInput2);
                // Crea un input
                var mapInput3 = document.createElement("input");
                mapInput3.type = "hidden";
                mapInput3.name = "Ds_Signature";
                mapInput3.value = respuesta.data.signature;
                // Añade el input al formulario
                mapForm.appendChild(mapInput3);
                // Añade el formulario al dom
                document.body.appendChild(mapForm);
                // Hace el submit del formulario
                mapForm.submit();
              }
            })
            .catch((error) => {
               console.log('error: ',error)
            });
          }  
        }

          

        
      },
      
      
      
    },
    computed: {
      urlpoliticas() {
        try {
          return this.$store.state.urlpoliticas || localStorage.getItem('urlpoliticas') || '/cookies'
        } catch (e) {
          return '/cookies'
        }
      }
    },
    mounted() {
      // 1. Configuración inicial de estilos y variables
      var numIdioma = this.$store.state.idiomas[this.$store.state.idioma]
      this.headerSimple = this.$store.state.header_simple
      this.logo_altura = this.$store.state.logo_altura
      
      // 2. Construcción de la ruta del JSON
      var cadJson = 'json/nosotros' + numIdioma.toString() + '.json'
      
      // 3. Carga con "Anti-Caché" (recomendado mantenerlo para evitar problemas futuros)
      var urlSinCache = RUTA_BASE + cadJson + '?t=' + new Date().getTime();

      axios.get(urlSinCache)
      .then(response => {
          this.mensajes = response.data.mensajes
          this.lockrecur = response.data.lockrecur;
          // 4. Lectura robusta de la variable:
          // Funciona perfecto tanto si en el JSON pones: "deshabilitaCheck": true
          // como si pones: "deshabilitaCheck": "true"
          this.deshabilitaCheck = String(response.data.deshabilitaCheck) === "true";

          // 5. Cargar resto de datos del formulario
          this.leeDatos()
      })
      .catch(error => {
          console.log("Error cargando configuración:", error)
      })
    }
  }
  
  function miorden() {
    var fecha = new Date()
    var ano = fecha.getFullYear()
    var mes = fecha.getMonth()+1
    var dia = fecha.getDate()
    var h = fecha.getHours()
    var m = fecha.getMinutes()
    var s = fecha.getSeconds()
    var o = ano.toString().substring(2,4)+mes.toString()+dia.toString()+h.toString()+m.toString()+s.toString()
    return o
  }
  
  function getId() {
    //var newTime = parseInt(moment().format("X")) - 1546300800;//seconds since 01/01/2019
    var newTime = Math.floor((new Date()).getTime() / 1000) - 1546300800;//seconds since 01/01/2019
    return newTime.toString(36);
  }
  
  function getRandomInt(min, max) {
    return Math.floor(Math.random() * (max - min)) + min;
  }
</script>
<style>
/* 1. Quitamos la transparencia general del componente */
.checkbox-texto-fijo,
.checkbox-texto-fijo.disabled {
    opacity: 1 !important;
    display: flex; /* Asegura alineación horizontal */
    align-items: center; /* Centra verticalmente texto y cuadrado */
    
}

/* 2. Estilizado del TEXTO */
.checkbox-texto-fijo label,
.checkbox-texto-fijo .form-check-label {
    color: #2c2c2c !important;      /* Gris oscuro elegante (no negro puro) */
    opacity: 1 !important;          /* Totalmente visible */
    cursor: not-allowed;            /* Icono prohibido al pasar ratón */
    
    /* MEJORAS VISUALES AQUÍ: */
    font-size: 14px !important;     /* Tamaño legible (ajusta a 15px o 16px si quieres) */
    font-weight: 500 !important;    /* Grosor: 400 es normal, 500 semi-negrita, 700 negrita */
    padding-left: 35px !important;  /* Espacio entre el cuadradito y el texto */
    line-height: 1.4 !important;    /* Altura de línea para que se lea bien */
    margin-top: 2px;                /* Pequeño ajuste vertical si lo ves desnivelado */
}

/* 3. Estilizado del CUADRADITO (Input) */
/* Lo dejamos un poco transparente para que se note que no se puede clicar */
.checkbox-texto-fijo .form-check-input:disabled + .form-check-sign::before,
.checkbox-texto-fijo .form-check-input:disabled + .form-check-sign::after {
    opacity: 0.6 !important;
}
</style>
